import List from './List';

export default List;



// WEBPACK FOOTER //
// ./src/components/ProductsPage/components/List/index.js